import React, { useEffect, useState } from 'react'
import Main from '../Components/Main';
import PageContainer from '../Components/PageContainer';
import Modal from '../Components/Modal';
import ContractorForm from '../Components/ContractorForm';
import CollapseCard from '../Components/CollapseCard';
import ContractorList from '../Components/ContractorList';
import { getAllContractors, saveContractor,updateContractor } from '../Service/ContractorService';
import { useToast } from '../Components/toast/ToastProvider';

const ContractorPage = () => {

    const [contractorForm, setContractorForm] = useState({
        name: '',
        contact_number: ''
    });

    const toast = useToast();

    const [contractorData, setContractorData] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchContractor();
    }, []);

    const fetchContractor = async () => {
        try {

            const res = await getAllContractors();

            setContractorData(res.data);

        } catch (err) {

            toast(
                err.message || 'Failed to fetch contractors',
                "ERROR"
            );

        }
    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (
            !contractorForm.name ||
            !contractorForm.contact_number
        ) {

            toast(
                'Please fill all fields',
                "ERROR"
            );

            return;
        }


        // Check duplicate contractor name
        const exist = contractorData.find(
            c =>
                c.name.toLowerCase() ===
                contractorForm.name.toLowerCase() &&
                c.id !== contractorForm.id
        );

        if (exist) {

            toast(
                'Contractor already exists',
                "ERROR"
            );

            return;
        }


        try {
             if (contractorForm.id) {
            
                    await updateContractor(contractorForm);
            
                    toast(
                      "Contractor updated successfully",
                      "SUCCESS"
                    );
            
                  } else {
            
                    await saveContractor(contractorForm);
            
                    toast(
                      "Contractor added successfully",
                      "SUCCESS"
                    );
                }

            fetchContractor();

            handleCancel();

        } catch (err) {

            toast(
                err.message || 'Failed to save contractor',
                'ERROR'
            );

        }
    };


    const handleChange = (e) => {

        const {
            name,
            value
        } = e.target;

        setContractorForm(prev => ({
            ...prev,
            [name]: value
        }));

    };


    const handleEdit = (item) => {

        setContractorForm({
            id: item.id,
            name: item.name,
            contact_number: item.contact_number
        });

        setShowModal(true);

    };


    const handleCancel = () => {

        setContractorForm({
            name: '',
            contact_number: ''
        });

        setShowModal(false);

    };


    return (
        <>
            <Main>

                <PageContainer
                    titlePage='Contractor'
                    buttonText='ADD'
                    onButtonClick={() => {
                        setShowModal(true);
                    }}
                >

                    <Modal
                        visible={showModal}
                        size='lg'
                        onClose={handleCancel}
                        headerText={
                            contractorForm.id
                                ? 'Edit Contractor'
                                : 'Add Contractor'
                        }
                    >

                        <ContractorForm
                            handleChange={handleChange}
                            contractorForm={contractorForm}
                            handleSubmit={handleSubmit}
                            handleCancel={handleCancel}
                            setContractorForm={setContractorForm}
                        />

                    </Modal>


                    <CollapseCard title='Contractor'>

                        <ContractorList
                            contractorData={contractorData}
                            handleEdit={handleEdit}
                        />

                    </CollapseCard>

                </PageContainer>

            </Main>
        </>
    );
};

export default ContractorPage;